import React, { useContext, useEffect, useState } from "react";
import Navbar from "../../layout/Navbar/Navbar";
import Sidebar from "../../layout/Sidebar/SideBar";
import blogFetch from "../../axios/config";
import { Col, Container, Row } from "react-bootstrap";
import { TableWagonToAnalyze } from "./components/TableWagonsToAnalyze";


export const WagonsToAnalyze = () => {

  return (
    <>
      <Navbar />
      <Sidebar />

      <Container className="app_body" fluid>
        <Row>
          <TableWagonToAnalyze />
        </Row>
      </Container>
    </>
  )
}